import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { Card } from '@hivebrite/design-system/Card';
import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';

import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';
import useOutboxedFontTheme from 'hb-react/shared/hooks/theme/useOutboxedFontTheme';
import ThemeProvider from 'hb-react/style/ThemeProvider';

import { useTopicsIndexContext } from '../contexts/TopicsIndexContext';
import useTopicsMenuName from '../hooks/useTopicsMenuName';

const TopicEmptyCard = () => {
  const outboxedFontTheme = useOutboxedFontTheme();
  const { areUsingFilters, resetFilters, isConnectedUser } =
    useTopicsIndexContext();
  const customTopicsMenuName = useTopicsMenuName();
  const menuName = isConnectedUser
    ? customTopicsMenuName
    : s__('Topics|Topics');

  return (
    <Grid>
      <Row>
        <Col width={6 / 12}>
          <ThemeProvider
            theme={outboxedFontTheme.themeName}
            fontBrightness={outboxedFontTheme.fontBrightness}
          >
            <Box font="h2-semibold" data-testid="topic-empty-card">
              <Dotdotdot clamp={2}>
                {`${s__('Topics|%{menuName}').i__({
                  menuName,
                })} ${areUsingFilters ? 'found' : ''} (0)`}
              </Dotdotdot>
            </Box>
          </ThemeProvider>
        </Col>
      </Row>
      <Row mb={8}>
        <Col width={6 / 12}>
          <Card>
            {areUsingFilters ? (
              <>
                <Box display="block" font="h4-regular">
                  {__('No matches found based on your search criteria.')}
                </Box>

                <Button mt={3} onClick={resetFilters}>
                  {__('Clear all filters')}
                </Button>
              </>
            ) : (
              <Box display="block" font="h4-regular">
                {__('No data found.')}
              </Box>
            )}
          </Card>
        </Col>
      </Row>
    </Grid>
  );
};

export default TopicEmptyCard;
